import { AxiosInstance } from 'axios';
import { ENV_CONFIG } from '@/envConfig.ts';

export const BUILD_OUTDATED_EVENT = 'app:outdated-build';

export function setupBuildVersionInterceptor(axiosInstance: AxiosInstance) {
  const requestId = axiosInstance.interceptors.request.use((config) => {
    if (ENV_CONFIG.buildNumber) {
      config.headers['X-Build-Number'] = ENV_CONFIG.buildNumber;
    }
    return config;
  });

  const responseId = axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 409) {
        window.dispatchEvent(new CustomEvent(BUILD_OUTDATED_EVENT));
      }
      return Promise.reject(error);
    }
  );

  return { requestId, responseId };
}
